import { Spinner, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const GeneratingOfferLoading = () => {
    return (
        <div className="flex flex-col items-center gap-l px-xl py-2xl text-center">
            <Spinner />
            <Text className="text-m text-structure-40">
                <FormattedMessage
                    id="_.credit_card_waitlist.generating_offer.loading"
                    defaultMessage="Loading your offer..."
                />
            </Text>
        </div>
    );
};
